import type { CSSProperties } from 'vue';

import type { AvatarProps } from '../Avatar';

export interface DropdownProps {
	mode?: 'click' | 'hover';
	nostyle?: boolean;
	open?: boolean;
	width?: string;
	height?: string;
	maxHeight?: string;
	closeOnDescendant?: boolean;
	direction?: DropdownDirections;
	styles?: object;
	maxWidth?: string;
	disabled?: boolean;
	fitContent?: boolean;
	debounce?: number;
	noShow?: boolean;
	stop?: boolean;
}

export enum DropdownItemTextStyle {
	quiet = 'quiet',
	normal = 'normal',
}

export enum DropdownItemIconStyle {
	rounded = 'rounded',
	normal = 'normal',
}

export interface DropdownItemProps {
	label?: string;
	contentRight?: {
		icon?: string;
		iconColor?: DropdownItemColors;
		text?: string;
		textColor?: DropdownItemColors;
		style?: DropdownItemTextStyle;
		iconStyle?: DropdownItemIconStyle;
	};
	labelColor?: DropdownItemColors;
	backGroundColor?: DropdownItemColors;
	iconLeft?: string;
	iconLeftColor?: DropdownItemColors;
	checked?: boolean;
	checkbox?: boolean;
	highlight?: string;
	avatar?: AvatarProps;
	loading?: boolean;
	/** Give the component the ability to overflow its content */
	overflows?: boolean;
	fontSize?: '12' | '13';
	fontWeight?: string;
	disabled?: boolean;
	flex?: boolean;
	noHover?: boolean;
	cursor?: string;
	textElipsis?: boolean;
	stop?: boolean;
	customStyles?: CSSProperties;
	hasSubmenu?: boolean;
}

export interface DropdownTitleProps {
	icon: string;
	label: string;
}

export enum DropdownGeneratorActionType {
	title = 'title',
	separator = 'separator',
	item = 'item',
}

export interface DropdownGeneratorAction {
	type: DropdownGeneratorActionType;
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	item?: any;
	title?: DropdownTitleProps;
}

export interface DropdownGeneratorProps {
	actions: DropdownGeneratorAction[];
	// biome-ignore lint/suspicious/noExplicitAny: Init Biome
	relatedData?: any;
}

export enum DropdownItemColors {
	white = 'white',
	blue = 'blue',
	purple = 'purple',
	red = 'red',
	orange = 'orange',
	yellow = 'yellow',
	green = 'green',
	grey = 'grey',
	lightGrey = 'lightGrey',
	black = 'black',
}

export type supporttedEventNames =
	| 'click'
	| 'mouseenter'
	| 'mouseleave'
	| 'clickaway'
	| 'descendant-click';

export enum DropdownDirections {
	AUTOMATIC = 'automatic',
	TOP = 'top',
	BOTTOM = 'bottom',
	LEFT = 'left',
	RIGHT = 'right',
	TOP_CENTER = 'top-center',
	TOP_LEFT = 'top-left',
	TOP_RIGHT = 'top-right',
	BOTTOM_CENTER = 'bottom-center',
	BOTTOM_LEFT = 'bottom-left',
	BOTTOM_RIGHT = 'bottom-right',
}

export interface Position {
	left: number;
	top: number;
}

export interface ControlledDropdownProps {
	nostyle?: boolean;
	open: boolean;
	height?: string;
	width?: string;
	maxHeight?: string;
	maxWidth?: string;
	direction?: DropdownDirections;
	styles?: object;
	fitContent?: boolean;
	fullWidth?: boolean;
}
